// components/chakra/NavbarWithCallToAction/NavbarWithCallToAction.tsx

import {
  Box,
  Container,
  Flex,
  HStack,
  IconButton,
  Link,
  Avatar,
  useDisclosure,
  useColorMode,
} from "@chakra-ui/react";
import { Logo } from "../../../Logo";

import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
import { SecureMembershipButton, LoginWithSmsModal } from "../../../pages/authentication";
import { brandConfig, getColor } from "../../../brandConfig";
import { FiLogOut } from 'react-icons/fi';

export const NavbarWithCallToAction = () => {
  const { colorMode } = useColorMode();

  const { isOpen: isLoginOpen, onClose: onLoginClose } = useDisclosure();
  const navigate = useNavigate();
  const { isAuthenticated, user, logout } = useAuth();

  const handleLoginSuccess = () => {
    onLoginClose();
    window.location.reload();
  };

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <Box
        position="sticky"
        top={0}
        left={0}
        right={0}
        zIndex="sticky"
        bg={colorMode === 'light'
          ? "#FFFFFF"
          : "rgba(8, 9, 10, 0.95)"}
        backdropFilter="blur(10px)"
        borderBottom="1px solid"
        borderColor={colorMode === 'light'
          ? "#E2E8F0"
          : "rgba(255, 255, 255, 0.1)"}
        boxShadow={colorMode === 'light'
          ? "0 1px 3px rgba(0, 0, 0, 0.12)"
          : "0 4px 20px 0 rgba(0, 0, 0, 0.5)"}
        margin={0}
        padding={0}
        width="100%"
        overflow="hidden"
      >
        <Container maxW="7xl" position="relative" zIndex={1} px={{ base: 3, md: 6 }}>
          <Flex
            minH={{ base: "56px", md: "64px" }}
            py={{ base: 2, md: 4 }}
            align="center"
            justify="space-between"
            gap={{ base: 2, md: 4 }}
            width="100%"
          >
            <Link
              as={RouterLink}
              to="/"
              aria-label={`${brandConfig.siteName} home`}
              flexShrink={0}
            >
              <Logo />
            </Link>

          <HStack spacing={{ base: 1, md: 4 }} flexShrink={0}>
            {isAuthenticated ? (
              <HStack spacing={1}>
                <Avatar
                  size="sm"
                  name={`${user?.fName || user?.firstName || ""} ${user?.lName || user?.lastName || ""}`}
                  src={user?.profilePhoto || undefined}
                  bg={getColor("secondary", colorMode)}
                  cursor="pointer"
                  onClick={() => navigate("/profile")}
                  _hover={{ opacity: 0.8, transform: "scale(1.05)" }}
                  transition="all 0.2s"
                />
                <IconButton
                  aria-label="Logout"
                  icon={<FiLogOut />}
                  size="sm"
                  variant="ghost"
                  color="red.400"
                  onClick={handleLogout}
                  _hover={{
                    color: "red.500",
                    bg: "red.50",
                  }}
                />
              </HStack>
            ) : (
              <SecureMembershipButton />
            )}
          </HStack>
        </Flex>
      </Container>

      {/* SMS Login Modal */}
      <LoginWithSmsModal
        isOpen={isLoginOpen}
        onClose={onLoginClose}
        onLoginSuccess={handleLoginSuccess}
      />
    </Box>
  );
};